import type { PageEditorMode } from "./PageEditor";
import { createStoredPreference } from "./storedPreference";

/** The view mode the user last picked in the editor (WYSIWYG / Split View / Source), kept per browser. */
export const EDITOR_MODE_STORAGE_KEY = "ark.pageEditor.mode";
export const EDITOR_MODE_EVENT = "ark:page-editor-mode";
/** The mode before the user ever picks one. */
export const DEFAULT_EDITOR_MODE: PageEditorMode = "split";

/** A stored value as a mode; anything unknown is the default. */
export function parseEditorMode(value: unknown): PageEditorMode {
    return value === "wysiwyg" || value === "split" || value === "source" ? value : DEFAULT_EDITOR_MODE;
}

const preference = createStoredPreference<PageEditorMode>(EDITOR_MODE_STORAGE_KEY, EDITOR_MODE_EVENT, parseEditorMode, DEFAULT_EDITOR_MODE);

export const getEditorMode = preference.get;
export const setEditorMode = preference.set;
export const subscribeEditorMode = preference.subscribe;
export const useEditorMode = preference.use;
